import { Grid2 as Grid, Typography, Pagination } from '@mui/material';
import { COLORS } from '../../utils/Application_Constants';

const PaginationBar = ({ page, totalPages, handlePageChange, isLoading = false }) => (
    <Grid container justifyContent="space-between" alignItems="center">
        {!isLoading && (
            <Grid>
                <Typography sx={{ color: COLORS.LT_MIDNIGHT75, fontSize: 13, fontWeight: 400 }}>
                    {`Page ${page} of ${!totalPages ? 0 : totalPages}`}
                </Typography>
            </Grid>
        )}
        <Grid>
            {totalPages > 1 && (
                <Pagination
                    color="primary"
                    variant="outlined"
                    shape="rounded"
                    size="small"
                    page={page}
                    count={!totalPages ? 0 : totalPages}
                    onChange={handlePageChange}
                    sx={{
                        '& .MuiPagination-ul': { gap: 1 },
                        '& .MuiPaginationItem-outlined': {
                            margin: 0,
                            fontSize: 12,
                            color: COLORS.LT_MIDNIGHT75,
                            background: 'white',

                            '&.Mui-selected': {
                                backgroundColor: COLORS.LT_JOURNEY10,
                                color: COLORS.LT_JOURNEY,
                            },
                        },
                    }}
                />
            )}
        </Grid>
    </Grid>
);

export default PaginationBar;
